import { UserRole } from "../types/Irmao";
import { IEvento, IGrauDeSessao, ITipoDaSessao } from "../types/Evento";
import { intersectRoles } from "./sharedAuth";
import { Loja } from "../types/Loja";

export const grausDeSessao: IGrauDeSessao[] = [
  "Grau 1",
  "Grau 2",
  "Grau 3",
] as const;

export const tipoDeSessaoDeSomar: ITipoDaSessao[] = [
  {
    nome: `Somar`,
    abreviacao: "SOMAR",
    tipoDaEntidade: "somar",
    requerGrau: false,
    permissao: ["admin"],
    cor: "primary",
  },
  {
    nome: "Evento",
    abreviacao: "EVENT",
    tipoDaEntidade: "somar",
    requerGrau: false,
    permissao: ["admin"],
    cor: "primary",
  },
  {
    nome: "Filhas de Jó",
    abreviacao: "FDJ",
    tipoDaEntidade: "somar",
    requerGrau: false,
    permissao: ["admin", "admin-loja"],
    cor: "purple",
  },
  {
    nome: "Demolay",
    abreviacao: "DEMOL",
    tipoDaEntidade: "somar",
    requerGrau: false,
    permissao: ["admin", "admin-loja"],
    cor: "black",
  },
] as const;

export const tiposDeSessaoDeLoja: ITipoDaSessao[] = [
  {
    nome: "Ordinária - Instrução",
    abreviacao: "OR INS",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "green",
  },
  {
    nome: "Ordinária - Outras",
    abreviacao: "OR OUT",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "green",
  },
  {
    nome: "Ordinária - J. Ritualístico",
    abreviacao: "OR JAN",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "green",
  },
  {
    nome: "Ordinária - Finanças",
    abreviacao: "OR FIN",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "red",
    exclusivoDeLoja: true,
  },
  {
    nome: "Magna - Iniciação",
    abreviacao: "MG INI",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "orange",
  },
  {
    nome: "Magna - Elevação",
    abreviacao: "MG ELE",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "orange",
  },
  {
    nome: "Magna - Exaltação",
    abreviacao: "MG EXA",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "orange",
  },
  {
    nome: "Magna - Instalação",
    abreviacao: "MG INS",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "orange",
  },
  {
    nome: "Magna - Outras",
    abreviacao: "MG OUT",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "orange",
  },
  {
    nome: "Extraordinária",
    abreviacao: "EXTRD",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "red",
    exclusivoDeLoja: true,
  },
  {
    nome: "Pública",
    abreviacao: "PUBL",
    tipoDaEntidade: "loja",
    requerGrau: true,
    permissao: ["admin-loja"],
    cor: "black",
  },
] as const;

export const tiposDeSessaoDePotencia: ITipoDaSessao[] = [
  {
    nome: "GOB",
    abreviacao: "GOB",
    tipoDaEntidade: "potencia",
    requerGrau: false,
    permissao: ["admin-potencia"],
    cor: "orange",
  },
  {
    nome: "GOSC",
    abreviacao: "GOSC",
    tipoDaEntidade: "potencia",
    requerGrau: false,
    permissao: ["admin-potencia"],
    cor: "orange",
  },
  {
    nome: "GLSC",
    abreviacao: "GLSC",
    tipoDaEntidade: "potencia",
    requerGrau: false,
    permissao: ["admin-potencia"],
    cor: "orange",
  },
] as const;

export const tiposDeSessao = [
  ...tiposDeSessaoDeLoja,
  ...tiposDeSessaoDePotencia,
  ...tipoDeSessaoDeSomar,
] as const;

export const temPermissaoDeSessao = (
  tipoDeSessao: ITipoDaSessao,
  permitido: UserRole | UserRole[] | null,
) => {
  return intersectRoles(tipoDeSessao.permissao, permitido);
};

export function eventoDeLoja(
  evento: IEvento,
): evento is Omit<IEvento, "entidade"> & { entidade: Loja } {
  return evento.tipoDaSessao.tipoDaEntidade === "loja";
}

export function dataEHoraDoEvento(evento: IEvento) {
  const horario =
    evento.horario ||
    (eventoDeLoja(evento) && evento.entidade.horarioDaSessao) ||
    "18:00";
  return `${evento.data}T${horario}:00`;
}
